import { useRef, useState } from "react";
import PropTypes from "prop-types";
import { IconButton } from "@mui/material";
import { Button } from "components/ui_new/index";
import { useSelector, useDispatch } from "react-redux";
import selectors from "selectors";
import FileUploadInput from "./file-upload-input";
import { uploadPatientDocument } from "actions/documents";
import { Formik } from "formik";
import * as Yup from "yup";
import useTranslate from "hooks/use-translate-language";
import { Spinner } from "components/ui";
import { Close } from "@mui/icons-material";
import { TextInput, SelectInput } from "components/form_new";
import "./documents.scss";

const UploadPatientDocumentForm = ({ closeModal }) => {
  const translate = useTranslate();
  const categories = useSelector(selectors.getDocumentCategories);
  const dispatch = useDispatch();
  const fileRef = useRef();
  const [isFetching, setIsFetching] = useState(false);

  // Transform categories for SelectInput
  const categoryOptions = categories.map(
    ({ document_category_name, document_category_id }) => ({
      text: translate(document_category_name),
      value: document_category_id
    })
  );
  return (
    <div className="documents-screen">
      <IconButton
        onClick={closeModal}
        aria-controls="close-document"
        aria-label="add-document"
        aria-haspopup="true"
        size="small"
        type="button"
        className="upload-form-close-icon"
      >
        <Close />
      </IconButton>
      <h3 className="upload-form-title">{translate("uploadDocument")}</h3>
      <Formik
        initialValues={{
          file: null,
          title: "",
          description: "",
          document_category_id: ""
        }}
        onSubmit={async values => {
          try {
            setIsFetching(true);
            const result = await dispatch(uploadPatientDocument(values));
            // Keep the form open when the upload was rejected (the action shows the reason).
            if (result?.success !== false) closeModal();
          } finally {
            setIsFetching(false);
          }
        }}
        validationSchema={Yup.object().shape({
          file: Yup.mixed().required(translate("required")),
          title: Yup.string().required(translate("required")),
          document_category_id: Yup.string().required(translate("required"))
        })}
      >
        {({ setFieldValue, handleSubmit }) => (
          <div className="upload-form-container">
            <div className="form-field">
              <TextInput label={translate("title")} name="title" type="text" />
            </div>
            <div className="form-field">
              <TextInput
                label={translate("notes")}
                name="description"
                type="text"
                // multiline
                // rows={3}
              />
            </div>
            <div className="form-field">
              <SelectInput
                label={translate("selectCategory")}
                name="document_category_id"
                options={categoryOptions}
              />
            </div>
            <div className="upload-form-buttons">
              <FileUploadInput
                ref={fileRef}
                onChange={event => {
                  setFieldValue("file", event.currentTarget.files[0]);
                }}
                onRemove={() => {
                  setFieldValue("file", null);
                }}
              />
              {isFetching ? (
                <Spinner />
              ) : (
                <Button
                  variant="contained"
                  type="submit"
                  onClick={handleSubmit}
                  className="submit-button"
                >
                  {translate("submit")}
                </Button>
              )}
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
};

UploadPatientDocumentForm.propTypes = {
  closeModal: PropTypes.func.isRequired
};

export default UploadPatientDocumentForm;
